const IS_DEV = process.env.NODE_ENV === "development";
let HOST = IS_DEV ? 'http://localhost:7099' : process.env.REACT_APP_SERVER_URL;

// Empty string is intentional (Docker/nginx proxy — API calls go to same origin)
// Only fall back to localhost if REACT_APP_SERVER_URL is truly undefined
if (HOST === undefined || HOST === null) {
    console.error("REACT_APP_SERVER_URL is not defined in the environment variables!");
    HOST = 'http://localhost:7099';
}
const API_PREFIX = 'api';

export const BASE_URL = `${HOST}/${API_PREFIX}`;

export const Post_addBranch = `${BASE_URL}/coworking/branches`;
export const Get_getBranches = `${BASE_URL}/coworking/branches`;
export const Get_getBranchById = (branchId) => `${BASE_URL}/coworking/branches/${branchId}`;
export const Put_updateBranch = (branchId) => `${BASE_URL}/coworking/branches/${branchId}`;
export const Delete_deleteBranch = (branchId) => `${BASE_URL}/coworking/branches/${branchId}`;

export const Post_GetCoordinates = `${BASE_URL}/utils/get-coordinates`;

export const Get_getBuildings = (branchId) => `${BASE_URL}/coworking/branches/${branchId}/buildings`;
export const Post_addBuilding = (branchId) => `${BASE_URL}/coworking/branches/${branchId}/buildings`;
export const Get_getBuildingById = (buildingId) => `${BASE_URL}/coworking/buildings/${buildingId}`;
export const Put_updateBuilding = (buildingId) => `${BASE_URL}/coworking/buildings/${buildingId}`;
export const Delete_deleteBuilding = (buildingId) => `${BASE_URL}/coworking/buildings/${buildingId}`;

// ** ----------------------------------------------------------------------------------------------------- Floor routes
export const Get_getFloors = (buildingId) => `${BASE_URL}/coworking/buildings/${buildingId}/floors`
export const Post_addFloor = (buildingId) => `${BASE_URL}/coworking/buildings/${buildingId}/floors`
export const Get_getFloorOptions = () => `${BASE_URL}/options/floors`
export const Get_getFloorById = (floorId) => `${BASE_URL}/coworking/floors/${floorId}`
export const Put_updateFloor = (floorId) => `${BASE_URL}/coworking/floors/${floorId}`
export const Delete_deleteFloor = (floorId) => `${BASE_URL}/coworking/floors/${floorId}`

// ** ----------------------------------------------------------------------------------------------------- Office routes
export const Get_getOffices = (floorId) => `${BASE_URL}/coworking/floors/${floorId}/offices`;
export const Post_addOffice = (floorId) => `${BASE_URL}/coworking/floors/${floorId}/offices`;
export const Get_getOfficeById = (officeId) => `${BASE_URL}/coworking/offices/${officeId}`;
export const Put_updateOffice = (officeId) => `${BASE_URL}/coworking/offices/${officeId}`;
export const Delete_deleteOffice = (officeId) => `${BASE_URL}/coworking/offices/${officeId}`;

// ** ----------------------------------------------------------------------------------------------------- Seat routes
export const Get_getSeats = (spaceId) => `${BASE_URL}/coworking/spaces/${spaceId}/seats`;
export const Post_addSeat = (spaceId) => `${BASE_URL}/coworking/spaces/${spaceId}/seats`;
export const Get_getSeatById = (seatId) => `${BASE_URL}/coworking/seats/${seatId}`;
export const Put_updateSeat = (seatId) => `${BASE_URL}/coworking/seats/${seatId}`;
export const Delete_deleteSeat = (seatId) => `${BASE_URL}/coworking/seats/${seatId}`;
export const Patch_updateSeatStatus = (seatId) => `${BASE_URL}/coworking/seats/${seatId}/status`;

// ** ----------------------------------------------------------------------------------------------------- Coworking routes
export const Get_getCoWorkingSpaces = (floorId) => `${BASE_URL}/coworking/floors/${floorId}/spaces`;
export const Post_addCoWorkingSpace = (floorId) => `${BASE_URL}/coworking/floors/${floorId}/spaces`;
export const Get_getCoWorkingSpaceById = (spaceId) => `${BASE_URL}/coworking/spaces/${spaceId}`;
export const Put_updateCoworkingSpaces = (spaceId) => `${BASE_URL}/coworking/spaces/${spaceId}`;
export const Delete_deleteCoworkingSpace = (spaceId) => `${BASE_URL}/coworking/spaces/${spaceId}`;

// ** ----------------------------------------------------------------------------------------------------- User routes
export const Get_getUsers = `${BASE_URL}/auth/users`;
export const Post_addUser = `${BASE_URL}/auth/users`;
export const Get_getUserById = (userId) => `${BASE_URL}/auth/users/${userId}`;
export const Put_updateUser = (userId) => `${BASE_URL}/auth/users/${userId}`;
export const Put_updateTeamMemberPermissions = (userId) => `${BASE_URL}/auth/users/team-member/${userId}/allowed-pages`;
export const Delete_deleteUser = (userId) => `${BASE_URL}/auth/users/${userId}`;
export const Delete_deleteTeamMember = (userId) => `${BASE_URL}/auth/users/team-member/${userId}`;
export const Post_loginUser = `${BASE_URL}/auth/login`;
export const Put_updateMeetingRoomQuota = (userId) => `${BASE_URL}/auth/users/${userId}/meeting-room-quota`;
export const Put_updateTeamMemberMeetingRoomQuota = (userId) => `${BASE_URL}/auth/users/team-member/${userId}/meeting-room-quota`;
export const Get_getMeetingRoomQuotaDefaults = `${BASE_URL}/auth/settings/meeting-room-quota-default`;
export const Put_updateMeetingRoomQuotaDefaults = `${BASE_URL}/auth/settings/meeting-room-quota-default`;
export const Get_exportSecurityCsvTemplate = `${BASE_URL}/auth/settings/csv/security/export`;
export const Post_dryRunSecurityCsvImport = `${BASE_URL}/auth/settings/csv/security/import/dry-run`;
export const Post_applySecurityCsvImport = `${BASE_URL}/auth/settings/csv/security/import/apply`;
export const Put_updateUserStatus = (userId) => `${BASE_URL}/auth/users/${userId}/login-status`;
export const Post_sendResetPasswordEmail = (userId) => `${BASE_URL}/auth/users/${userId}/send-reset-password-email`;
export const Post_requestPasswordReset = `${BASE_URL}/auth/password-reset/request`;
export const Post_completePasswordReset = `${BASE_URL}/auth/password-reset/complete`;
export const Post_forceResetPassword = (userId) => `${BASE_URL}/auth/users/${userId}/force-password-reset`;
export const Get_revealPassword = (userId) => `${BASE_URL}/auth/users/${userId}/reveal-password`;
export const Post_markPasswordChanged = `${BASE_URL}/auth/users/password-changed`;

// ** ----------------------------------------------------------------------------------------------------- Booking routes
export const Get_getBookings = `${BASE_URL}/gig/reservations`;
export const Post_addBooking = `${BASE_URL}/gig/reservation`;
export const Get_getBookingById = (bookingId) => `${BASE_URL}/gig/reservation/${bookingId}`;
export const Put_updateBooking = (bookingId) => `${BASE_URL}/gig/reservation/${bookingId}`;
export const Delete_deleteBooking = (bookingId) => `${BASE_URL}/gig/reservation/${bookingId}`;
export const Patch_updateBookingStatus = (bookingId) => `${BASE_URL}/gig/reservation/${bookingId}/status`;
export const Get_getBookingsByContract = (contractId) => `${BASE_URL}/gig/reservation/contract/${contractId}`;
export const Get_getBookingsByUser = (userId) => `${BASE_URL}/gig/reservation/user/${userId}`;
export const Get_getBookingsBySeat = (seatId) => `${BASE_URL}/gig/reservation/seat/${seatId}`;


// ** ----------------------------------------------------------------------------------------------------- Contract routes
export const Get_getContracts = `${BASE_URL}/gig/contract`;
export const Post_addContract = `${BASE_URL}/gig/contract`;
export const Get_getContractById = (contractId) => `${BASE_URL}/gig/contract/${contractId}`;
export const Put_updateContract = (contractId) => `${BASE_URL}/gig/contract/${contractId}`;
export const Delete_deleteContract = (contractId) => `${BASE_URL}/gig/contract/${contractId}`;
export const Patch_updateContractStatus = (contractId) => `${BASE_URL}/gig/contract/${contractId}/status`;
export const Get_getUserContracts = (userId) => `${BASE_URL}/gig/contract/user/${userId}`;
export const Get_getUserOwnContracts = `${BASE_URL}/gig/my-contracts`;
export const Patch_updateContractWithCompletedBookings = (contractId) => `${BASE_URL}/gig/contract/${contractId}/terminate`;
export const Patch_freezeBooking = (bookingId) => `${BASE_URL}/gig/reservation/${bookingId}/freeze`;
export const Patch_unfreezeBooking = (bookingId) => `${BASE_URL}/gig/reservation/${bookingId}/unfreeze`;
export const Patch_updateFreezeDates = (bookingId) => `${BASE_URL}/gig/reservation/${bookingId}/freeze-dates`;


// ** ----------------------------------------------------------------------------------------------------- Meeting room routes
export const Get_getMeetingRooms = (floorId) => `${BASE_URL}/coworking/floors/${floorId}/meeting-rooms`;
export const Post_addMeetingRoom = (floorId) => `${BASE_URL}/coworking/floors/${floorId}/meeting-rooms`;
export const Get_getMeetingRoomById = (meetingRoomId) => `${BASE_URL}/coworking/meeting-rooms/${meetingRoomId}`;
export const Put_updateMeetingRoom = (meetingRoomId) => `${BASE_URL}/coworking/meeting-rooms/${meetingRoomId}`;
export const Delete_deleteMeetingRoom = (meetingRoomId) => `${BASE_URL}/coworking/meeting-rooms/${meetingRoomId}`;


// ** ----------------------------------------------------------------------------------------------------- Meeting room booking routes
export const Get_getMeetingRoomBookings = `${BASE_URL}/gig/booking/meeting-room`;
export const Post_addMeetingRoomBooking = `${BASE_URL}/gig/booking/meeting-room`;
export const Get_getMeetingRoomBookingById = (bookingId) => `${BASE_URL}/gig/booking/meeting-room/${bookingId}`;
export const Put_updateMeetingRoomBooking = (bookingId) => `${BASE_URL}/gig/booking/meeting-room/${bookingId}`;
export const Put_cancelMeetingRoomBooking = (bookingId) => `${BASE_URL}/gig/booking/meeting-room/${bookingId}/cancel`;
export const Post_addTeamMemberMeetingRoomBooking = `${BASE_URL}/gig/booking/team-member/meeting-room`;

// router.delete('/booking/meeting-room/:bookingId', verifyToken, deleteMeetingRoomBooking);

// ** ----------------------------------------------------------------------------------------------------- Stats routes
export const Get_getDashboardStats = `${BASE_URL}/stats`;
export const Post_refreshDashboardStats = `${BASE_URL}/stats/refresh`;
export const Get_getCustomerDashboardStats = `${BASE_URL}/stats/customer`;
export const Get_getTeamMemberDashboardStats = `${BASE_URL}/stats/team-member`;
export const Get_getRentBreakdown = `${BASE_URL}/stats/rent-breakdown`;
export const Get_getSecurityBreakdown = `${BASE_URL}/stats/security-breakdown`;
export const Get_getCustomersStats = `${BASE_URL}/stats/users`;


// ** ----------------------------------------------------------------------------------------------------- Lead routes
export const Get_getLeads = `${BASE_URL}/lead`
export const Post_addLead = `${BASE_URL}/lead`
export const Get_searchLeads = `${BASE_URL}/lead/search`
export const Get_getLeadsByRep = (repId) => `${BASE_URL}/lead/rep/${repId}`
export const Get_getLeadById = (leadId) => `${BASE_URL}/lead/${leadId}`
export const Put_updateLead = (leadId) => `${BASE_URL}/lead/${leadId}`
export const Delete_deleteLead = (leadId) => `${BASE_URL}/lead/${leadId}`
export const Post_addEngagement = (leadId) => `${BASE_URL}/lead/${leadId}/engagement`
export const Put_updateEngagement = (leadId, engagementId) => `${BASE_URL}/lead/${leadId}/engagement/${engagementId}`
export const Post_addTeamMemberByAdmin = `${BASE_URL}/auth/users/team-member-by-admin`
export const Post_addTeamMember = `${BASE_URL}/auth/users/team-member`

// ** ----------------------------------------------------------------------------------------------------- Quotation routes
export const Get_getQuotationDefaults = `${BASE_URL}/quotation/settings/defaults`
export const Put_updateQuotationDefaults = `${BASE_URL}/quotation/settings/defaults`
export const Get_getQuotationsByLead = (leadId) => `${BASE_URL}/quotation/lead/${leadId}`
export const Post_createQuotation = (leadId) => `${BASE_URL}/quotation/lead/${leadId}`
export const Get_getQuotationById = (quotationId) => `${BASE_URL}/quotation/${quotationId}`
export const Put_updateQuotation = (quotationId) => `${BASE_URL}/quotation/${quotationId}`
export const Delete_deleteQuotation = (quotationId) => `${BASE_URL}/quotation/${quotationId}`

// ** ----------------------------------------------------------------------------------------------------- Role routes (RBAC)
export const Post_createRole = `${BASE_URL}/role/`;
export const Get_getRoles = `${BASE_URL}/role/`;
export const Get_getRoleById = (roleId) => `${BASE_URL}/role/${roleId}`;
export const Put_updateRole = (roleId) => `${BASE_URL}/role/${roleId}`;
export const Delete_deleteRole = (roleId) => `${BASE_URL}/role/${roleId}`;

// ** ----------------------------------------------------------------------------------------------------- Customer support routes
export const Post_createTicket = `${BASE_URL}/support/ticket`;
export const Get_getTickets = `${BASE_URL}/support/ticket`;
export const Get_getTicketById = (ticketId) => `${BASE_URL}/support/ticket/${ticketId}`;
export const Put_updateTicket = (ticketId) => `${BASE_URL}/support/ticket/${ticketId}`;
export const Delete_deleteTicket = (ticketId) => `${BASE_URL}/support/ticket/${ticketId}`;
export const Get_getInteractions = (ticketId) => `${BASE_URL}/support/ticket/${ticketId}/interactions`;
export const Post_addInteraction = (ticketId) => `${BASE_URL}/support/ticket/${ticketId}/interactions`;
export const Post_acknowledgeResolution = (ticketId) => `${BASE_URL}/support/ticket/${ticketId}/acknowledge`;
export const Put_approveTicket = (ticketId) => `${BASE_URL}/support/ticket/${ticketId}/approve`;
export const Post_submitFeedback = (ticketId) => `${BASE_URL}/support/ticket/${ticketId}/feedback`;

export const Get_getAllTickets = `${BASE_URL}/support/admin/ticket`;
export const Get_getTicketDetails = (ticketId) => `${BASE_URL}/support/admin/ticket/${ticketId}`;
export const Get_getSupportSettings = `${BASE_URL}/support/admin/ticket/settings`;
export const Put_updateSupportSettings = `${BASE_URL}/support/admin/ticket/settings`;
export const Put_updateTicketStatus = (ticketId) => `${BASE_URL}/support/admin/ticket/${ticketId}/status`;
export const Put_assignTicket = (ticketId) => `${BASE_URL}/support/admin/ticket/${ticketId}/assign`;
export const Post_createTicketByAdmin = `${BASE_URL}/support/admin/ticket/create`;
export const Put_updateTicketDueDate = (ticketId) => `${BASE_URL}/support/admin/ticket/${ticketId}/due-date`;
export const Put_updateTicketPriority = (ticketId) => `${BASE_URL}/support/admin/ticket/${ticketId}/priority`;
export const Put_updateTicketLocation = (ticketId) => `${BASE_URL}/support/admin/ticket/${ticketId}/location`;
export const Get_supportDashboard = `${BASE_URL}/support/admin/dashboard`;
export const Get_supportTrend = `${BASE_URL}/support/admin/dashboard/trend`;
export const Get_supportCategories = `${BASE_URL}/support/categories`;
export const Post_createSupportCategory = `${BASE_URL}/support/admin/categories`;
export const Put_updateSupportCategory = (categoryId) => `${BASE_URL}/support/admin/categories/${categoryId}`;
export const Delete_supportCategory = (categoryId) => `${BASE_URL}/support/admin/categories/${categoryId}`;

// ** ----------------------------------------------------------------------------------------------------- Day pass routes

export const Post_createDayPass = `${BASE_URL}/gig/day-pass/create`; // If you want customers to create their own
export const Get_getDayPasses = `${BASE_URL}/gig/day-pass`;
export const Get_getDayPassById = (dayPassId) => `${BASE_URL}/gig/day-pass/${dayPassId}`;
export const Put_updateDayPass = (dayPassId) => `${BASE_URL}/gig/day-pass/${dayPassId}`;
export const Patch_approveDayPass = (dayPassId) => `${BASE_URL}/gig/day-pass/${dayPassId}/approve`;
export const Patch_checkInDayPass = (dayPassId) => `${BASE_URL}/gig/day-pass/${dayPassId}/checkin`;
export const Patch_checkOutDayPass = (dayPassId) => `${BASE_URL}/gig/day-pass/${dayPassId}/checkout`;
export const Patch_updateDayPassPaymentStatus = (dayPassId) => `${BASE_URL}/gig/day-pass/${dayPassId}/payment`;
export const Get_getDayPassesByDate = (date) => `${BASE_URL}/gig/day-pass/date/${date}`;
export const Get_getDayPassesByCustomerEmail = (email) => `${BASE_URL}/gig/day-pass/email/${email}`;
export const Get_getDayPassesByCustomerId = (customerId) => `${BASE_URL}/gig/day-pass/uid/${customerId}`;
export const Patch_cancelDayPass = (dayPassId) => `${BASE_URL}/gig/day-pass/${dayPassId}/cancel`;
export const Patch_extendDayPass = (dayPassId) => `${BASE_URL}/gig/day-pass/${dayPassId}/extend`;
export const Patch_completeDayPass = (dayPassId) => `${BASE_URL}/gig/day-pass/${dayPassId}/complete`;

// ** ----------------------------------------------------------------------------------------------------- Notification routes
export const Get_getUserNotifications = `${BASE_URL}/notification`;
export const Patch_markNotificationRead = (notificationId) => `${BASE_URL}/notification/${notificationId}/read`;
export const Patch_markAllNotificationsRead = `${BASE_URL}/notification/mark-all-read`;
export const Get_getUnreadNotificationCount = `${BASE_URL}/notification/unread-count`;

// ** ----------------------------------------------------------------------------------------------------- Impersonation routes
export const Post_startImpersonation = `${BASE_URL}/auth/impersonate/start`;
export const Post_stopImpersonation = `${BASE_URL}/auth/impersonate/stop`;

// ** ----------------------------------------------------------------------------------------------------- Invoice routes
export const Get_getInvoices = `${BASE_URL}/invoice`;
export const Get_getInvoiceStats = `${BASE_URL}/invoice/stats`;
export const Get_getInvoiceSettings = `${BASE_URL}/invoice/settings`;
export const Put_updateInvoiceSettings = `${BASE_URL}/invoice/settings`;
export const Get_getInvoiceById = (invoiceId) => `${BASE_URL}/invoice/${invoiceId}`;
export const Post_generateInvoices = `${BASE_URL}/invoice/generate`;
export const Patch_updateInvoiceStatus = (invoiceId) => `${BASE_URL}/invoice/${invoiceId}/status`;
export const Post_addInvoicePayment = (invoiceId) => `${BASE_URL}/invoice/${invoiceId}/payment`;
export const Post_customerMarkInvoicePaid = (invoiceId) => `${BASE_URL}/invoice/${invoiceId}/mark-paid`;
export const Patch_approveInvoicePayment = (invoiceId, paymentIndex) => `${BASE_URL}/invoice/${invoiceId}/payment/${paymentIndex}/approve`;
export const Patch_rejectInvoicePayment = (invoiceId, paymentIndex) => `${BASE_URL}/invoice/${invoiceId}/payment/${paymentIndex}/reject`;
export const Post_syncInvoice = (invoiceId) => `${BASE_URL}/invoice/${invoiceId}/sync`;
export const Patch_updateInvoiceDueDate = (invoiceId) => `${BASE_URL}/invoice/${invoiceId}/due-date`;
export const Put_updateInvoice = (invoiceId) => `${BASE_URL}/invoice/${invoiceId}`;
export const Patch_updateInvoicePayment = (invoiceId, paymentIndex) => `${BASE_URL}/invoice/${invoiceId}/payment/${paymentIndex}`;
export const Delete_invoicePayment = (invoiceId, paymentIndex) => `${BASE_URL}/invoice/${invoiceId}/payment/${paymentIndex}`;
export const Post_createManualInvoice = `${BASE_URL}/invoice/manual`;

// ** ----------------------------------------------------------------------------------------------------- Bank routes
export const Get_getBanks = `${BASE_URL}/bank`;
export const Get_getBankById = (bankId) => `${BASE_URL}/bank/${bankId}`;
export const Post_addBank = `${BASE_URL}/bank`;
export const Put_updateBank = (bankId) => `${BASE_URL}/bank/${bankId}`;
export const Delete_deleteBank = (bankId) => `${BASE_URL}/bank/${bankId}`;

// ** ----------------------------------------------------------------------------------------------------- Refund routes
export const Get_getRefunds = `${BASE_URL}/refund`;
export const Get_getRefundById = (refundId) => `${BASE_URL}/refund/${refundId}`;
export const Post_addRefund = `${BASE_URL}/refund`;
export const Put_updateRefund = (refundId) => `${BASE_URL}/refund/${refundId}`;
export const Delete_deleteRefund = (refundId) => `${BASE_URL}/refund/${refundId}`;

// ** ----------------------------------------------------------------------------------------------------- Inventory routes
export const Get_getInventoryDashboard = `${BASE_URL}/inventory/dashboard`;

export const Get_getInventoryItems = `${BASE_URL}/inventory/items`;
export const Post_addInventoryItem = `${BASE_URL}/inventory/items`;
export const Get_getInventoryItemById = (itemId) => `${BASE_URL}/inventory/items/${itemId}`;
export const Put_updateInventoryItem = (itemId) => `${BASE_URL}/inventory/items/${itemId}`;
export const Delete_deleteInventoryItem = (itemId) => `${BASE_URL}/inventory/items/${itemId}`;
export const Get_getInventoryItemHistory = (itemId) => `${BASE_URL}/inventory/items/${itemId}/history`;
export const Get_exportInventoryItemCsv = (itemId) => `${BASE_URL}/inventory/items/${itemId}/export`;

export const Get_getInventoryTransactions = (itemId) => `${BASE_URL}/inventory/items/${itemId}/transactions`;
export const Post_addInventoryTransaction = (itemId) => `${BASE_URL}/inventory/items/${itemId}/transactions`;

export const Get_getInventoryPhysicalCounts = (itemId) => `${BASE_URL}/inventory/items/${itemId}/physical-counts`;
export const Post_addInventoryPhysicalCount = (itemId) => `${BASE_URL}/inventory/items/${itemId}/physical-counts`;

export const Get_getInventoryConsumers = `${BASE_URL}/inventory/consumers`;
export const Post_addInventoryConsumer = `${BASE_URL}/inventory/consumers`;
export const Put_updateInventoryConsumer = (consumerId) => `${BASE_URL}/inventory/consumers/${consumerId}`;
export const Delete_deleteInventoryConsumer = (consumerId) => `${BASE_URL}/inventory/consumers/${consumerId}`;

export const Get_getInventoryConsumptionTrend = `${BASE_URL}/inventory/reports/consumption-trend`;
export const Get_getInventoryConsumptionByFloor = `${BASE_URL}/inventory/reports/consumption-by-floor`;
export const Get_getInventoryFloorItemBreakdown = `${BASE_URL}/inventory/reports/floor-item-breakdown`;
export const Get_getInventoryBreakageReport = `${BASE_URL}/inventory/reports/breakage`;
export const Get_getInventoryLowStockReport = `${BASE_URL}/inventory/reports/low-stock`;
export const Get_getInventoryCountMismatchesReport = `${BASE_URL}/inventory/reports/count-mismatches`;

export const Get_exportAllInventoryItemsCsv = `${BASE_URL}/inventory/export/items`;
export const Get_exportAllInventoryTransactionsCsv = `${BASE_URL}/inventory/export/transactions`;

export const Get_getInventoryCsvTemplate = `${BASE_URL}/inventory/csv/template`;
export const Post_dryRunInventoryCsvImport = `${BASE_URL}/inventory/csv/import/dry-run`;
export const Post_applyInventoryCsvImport = `${BASE_URL}/inventory/csv/import/apply`;

// ** ----------------------------------------------------------------------------------------------------- Maintenance routes
export const Get_getMaintenanceSummary = `${BASE_URL}/maintenance/summary`;
export const Get_getMaintenanceReports = `${BASE_URL}/maintenance/reports`;

export const Get_getMaintenanceWorkOrders = `${BASE_URL}/maintenance/work-orders`;
export const Post_addMaintenanceWorkOrder = `${BASE_URL}/maintenance/work-orders`;
export const Get_getMaintenanceWorkOrderById = (workOrderId) => `${BASE_URL}/maintenance/work-orders/${workOrderId}`;
export const Put_updateMaintenanceWorkOrder = (workOrderId) => `${BASE_URL}/maintenance/work-orders/${workOrderId}`;
export const Patch_updateMaintenanceWorkOrderStatus = (workOrderId) => `${BASE_URL}/maintenance/work-orders/${workOrderId}/status`;
export const Patch_updateMaintenanceWorkOrderCost = (workOrderId) => `${BASE_URL}/maintenance/work-orders/${workOrderId}/cost`;
export const Delete_deleteMaintenanceWorkOrder = (workOrderId) => `${BASE_URL}/maintenance/work-orders/${workOrderId}`;

export const Get_getMaintenanceInteractions = (workOrderId) => `${BASE_URL}/maintenance/work-orders/${workOrderId}/interactions`;
export const Post_addMaintenanceInteraction = (workOrderId) => `${BASE_URL}/maintenance/work-orders/${workOrderId}/interactions`;

// ** ----------------------------------------------------------------------------------------------------- Executive dashboard (snapshot DB)
export const Get_getExecutiveRange = `${BASE_URL}/executive`;
export const Post_refreshExecutiveToday = `${BASE_URL}/executive/refresh`;
export const Get_listExecutiveSnapshots = `${BASE_URL}/executive/snapshots`;

// ** ----------------------------------------------------------------------------------------------------- Finance archive (WBP-188 RO)
export const Get_financeArchiveMeta = `${BASE_URL}/finance/archive`;
export const Get_financeArchiveTransactions = `${BASE_URL}/finance/archive/transactions`;
export const Get_financeArchiveTransaction = (sourceId) => `${BASE_URL}/finance/archive/transactions/${encodeURIComponent(sourceId)}`;
export const Get_financeArchiveAccounts = `${BASE_URL}/finance/archive/accounts`;
export const Get_financeArchiveContactsAutocomplete = `${BASE_URL}/finance/archive/contacts/autocomplete`;
export const Get_financeArchiveDocuments = `${BASE_URL}/finance/archive/documents`;
export const Get_financeArchiveDocumentDownload = (sourceId) => `${BASE_URL}/finance/archive/documents/${encodeURIComponent(sourceId)}/download`;
export const Get_financeArchiveFileDownload = (gridFsId) => `${BASE_URL}/finance/archive/files/${encodeURIComponent(gridFsId)}/download`;

